export default {
  paginaAtual: 1,
  estaCarregando: false,
  order: '',
  direcao: '',
  todosItensCarregados: false,
  totalItens: null,
  listaModulo: [],
  listaModulosPais: [],
  moduloSelecionadoId: null,
  permissoes: [],
  objModulo: {
    nome: '',
    url: '',
    situacao: '',
    modulo_pai_id: '',
    favorito: null,
    filhos: 0
  }
}
